import { useNavigate } from "react-router-dom";
import { offerStatus } from "../../constants/commonConstants";
import { formatYYYY_MM_DD } from "../../utils/dateFormating";
import { currencyFormatter } from "../../utils/formatting";
import CustomButton from "../Form/CustomButton";

const ServiceOffer = ({ offer, isSender, acceptOfferMethod = () => {}, declineOfferMethod = () => {}, cancelOfferMethod = () => {}, threadId  }) => {

  const navigate = useNavigate();

  // const handleAcceptOffer = () => {
  //   // Send API call to accept offer
  //   // Update offer status
  // };

  const handleDeclineOffer = () => {
    // Send API call to decline offer
    // Update offer status
  };

  const handleCancelOffer = () => {};

  return (
    <div
      className={` ${
        isSender
          ? " bg-[#EDEEEE] rounded-[8px_0px_8px_8px]"
          : "bg-[#DDE1E6] rounded-[0px_8px_8px_8px]"
      } font-inter p-4 my-3 lg:p-6 w-full sm:w-[90%] md:max-w-[60%] lg:max-w-[60%] xl:max-w-[40%] `}
    >
      <h3 className="font-semibold leading-6 text-level-7 text-dark">
        {offer?.title || ""}
      </h3>
      <hr className="mb-6 my-4 h-[2px] bg-content" />
      <p className="leading-6 text-level-7 text-content">{offer?.description || ""}</p>
      <hr className="mt-2 mb-6 h-[1px] bg-[#C1C3C3]" />
      <div className="flex items-center lg:gap-x-10 gap-x-6">
        <div>
          <p className="mb-0 font-semibold leading-6 text-level-7 text-content">
            Date
          </p>
          <p className="leading-6 text-level-7 text-content">
            {formatYYYY_MM_DD(offer?.createdAt || null) || ""}
          </p>
        </div>
        <div>
          <p className="mb-0 font-semibold leading-6 text-level-7 text-content">
            Time
          </p>
          <p className="leading-6 text-level-7 text-content">{offer?.time}</p>
        </div>
        <div>
          <p className="mb-0 font-semibold leading-6 text-level-7 text-content">
            Price
          </p>
          <p className="leading-6 text-level-7 text-content">
            {currencyFormatter.format(offer?.amount || 0)}
          </p>
        </div>
      </div>
      {!isSender ? (
        <div className="">
          {/* Only show action buttons if not sender */}
          {offer?.status === offerStatus.PENDING && (
            <div className="flex flex-wrap mt-4">
              <CustomButton
                buttonText="Decline Offer"
                className="flex-1 bg-white rounded-none font-inter font-semibold text-level-7 text-[#0F161E] py-2 "
                onClick={() => {declineOfferMethod(offer?._id || "")}}
              />
              <CustomButton
                buttonText="Accept Offer"
                className="flex-1 bg-[#0F161E] rounded-none font-inter font-semibold text-level-7 text-white py-2 "
                onClick={() => navigate(`/client/checkout/${offer?._id}/${threadId}`)}
              />
            </div>
          )}
        </div>
      ) : (
        <div className="flex flex-wrap mt-4">
          {offer?.status === offerStatus.PENDING && (
            <CustomButton
              buttonText="Cancel Offer"
              className="flex-1 bg-[#0F161E] rounded-none font-inter font-semibold text-level-7 text-white py-2 "
              onClick={() => {cancelOfferMethod(offer?._id || "")}}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default ServiceOffer;
